export default __webpack_public_path__ + "static/media/right-arrow.5f7d4077.svg";